import sendRequest from "./sendRequest.js";

/**
 * Счётчик обратного отсчёта
 *
 * @param {Number} from
 * @param {Number} to
 */
function printNumbers(from, to) {
    "use strict";

    let current = from;
    let $domCounter = document.getElementById("js-back-counter");
    let $domSeconds = document.getElementById("js-back-counter-seconds");

    if (!!$domCounter) {
        let timerId = setInterval(function () {
            if (current === to) {
                clearInterval(timerId);
                document.location.reload(true);
            }
            $domCounter.textContent = current;
            $domSeconds.textContent = window.mainJs.getNoun(
                current,
                "секунду",
                "секунды",
                "секунд"
            );

            current--;
        }, 1000);
    }
}

/**
 * Замена или создание модального окна
 * @param {string} mhtml
 * @param {string} modalName
 * @param {function} onclose
 * @param {function} onsubmit
 */
function replaceModal(mhtml, modalName, onclose = null, onsubmit = null)
{
    let makeNew = false;
    if (document.getElementById(modalName) === null) {
        makeNew = true;
    }

    if (makeNew) {
        let modalHtml = '<div class="modal" id="' + modalName + '" data-modal-show="' + modalName + '">' +
        '<div class="modal__overlay"></div>' +
        '<div class="modal__container">' +
        '<svg class="modal__close" viewBox="0 0 9.414 9.414"><g transform="translate(-805.793 -334.793)"><line x2="8" y2="8" transform="translate(806.5 335.5)" fill="none" stroke-linecap="round" stroke-width="1"></line><line y1="8" x2="8" transform="translate(806.5 335.5)" fill="none" stroke-linecap="round" stroke-width="1"></line></g></svg>';
        modalHtml += mhtml;
        modalHtml += "</div></div>";
        //document.querySelector(".page-content").insertAdjacentHTML("beforeend", modalHtml);
        document.querySelector("body").insertAdjacentHTML("beforeend", modalHtml);
        document.addEventListener("click", function (e) {
            if (e.target.classList.contains("modal__close")) {
                let activeModal = e.target.closest(".modal--active");
                if (activeModal) {
                    activeModal.classList.remove("modal--active");
                    if (onclose !== null) {
                        onclose();
                    }
                }
            }
        });

        // Обработчик submit формы внутри модального окна
        if (onsubmit !== null) {
            document.getElementById(modalName).addEventListener("submit", onsubmit());
        } else {
            document.getElementById(modalName).addEventListener("submit", event => {
                event.preventDefault();
                const oForm = event.target;
                let method = oForm.getAttribute("method");
                let url = oForm.getAttribute("action");
                let data = {};
                oForm.querySelectorAll("input").forEach(elm => {
                    data[elm.name] = elm.value;
                });
                oForm.querySelector('button[type="submit"]').disabled = true;

                sendRequest({
                    url: url,
                    data: data,
                    method: method,
                    success: function (res) {
                        if (res.length > 0) {
                            replaceModal(res, modalName);
                        } else {
                            oForm.querySelector('button[type="submit"]').disabled = false;
                        }
                    }
                });
            });
        }
    } else {
        let modalHtml = '<svg class="modal__close" viewBox="0 0 9.414 9.414"><g transform="translate(-805.793 -334.793)"><line x2="8" y2="8" transform="translate(806.5 335.5)" fill="none" stroke-linecap="round" stroke-width="1"></line><line y1="8" x2="8" transform="translate(806.5 335.5)" fill="none" stroke-linecap="round" stroke-width="1"></line></g></svg>';
        modalHtml += mhtml;
        let modal = document.getElementById(modalName);
        modal.querySelector(".modal__container").innerHTML = modalHtml;

        // Костыль, чтобы запустить JS с счётчиком
        let $domCounter = document.getElementById("js-back-counter");
        if (!!$domCounter) {
            printNumbers(5, 0);
        }
    }

    // Заново инициализируем оформление полей ввода
    window.forms.init();

    // Заново инициализируем маску телефона
    window.masks.init();

    window.modal.showModal(modalName, 0);

    try {
        // Инициализация покупки в один клик
        let btns = document.querySelectorAll(".js-order-one-click");
        Array.prototype.forEach.call(btns, function (btn) {
            btn.addEventListener("click", function (event) {
                $("#loyalty-register").hide();
                window.modal.showModal("one-click-form", 0);
                window.basket.clickOrderOneClickHandler(event.target);
            });
        });
    } catch (e) {
        window.console.log(e);
    }
}

export {
    sendRequest,
    replaceModal
}